// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2jF3a","title":"Images90_title__1Rrhe","images":"Images90_images__3C6VY"};